export default __webpack_public_path__ + "resources/icons/n232-5f1c.png";